export const getCommonString = strings => {
  const allNames = strings.concat().sort()
  const a1 = allNames[0]
  const a2 = allNames[allNames.length - 1]
  const L = a1.length
  let i = 0
  while (i < L && a1.charAt(i) === a2.charAt(i)) i++
  return a1.substring(0, i).replace(/[^a-zA-Z0-9]*$/g, '')
}

export const getAcronym = str => {
  // By no means complete, but since regex unicode support
  // in JS is "hard", it's easier to keep a little list of things
  // to filter out
  const nonLetters = /[ -/:-@[-`{-~']/
  if (!str) return ''

  return str
    .split(' ')
    .map(part => part.charAt(0).toUpperCase())
    .filter(initial => !nonLetters.exec(initial))
    .join('')
}

/**
 * Returns the provided string the extension (last dot and following chars)
 * removed.
 * @param {string} filename
 * @returns the filename without file extension
 */
export const removeFileExtension = filename => {
  if (filename === '') {
    return filename
  }
  return splitOnFileExtension(filename)[0]
}

/**
 * Returns file extension for the provided string, or an empty string if no extension
 * is present. Note that the extension *does not* include the dot.
 *
 * Example:
 *
 * ```
 * "myfile.txt" => "txt"
 * ```
 *
 * @param {string} filename
 * @returns the filename's file extension
 */
export const getFileExtension = filename => {
  if (filename === '') {
    return filename
  }
  const parts = splitOnFileExtension(filename)
  if (parts.length < 2) {
    return ''
  } else {
    return parts[1]
  }
}

export const splitOnFileExtension = filename => {
  if (filename === '') {
    return filename
  }

  return filename.split(/\.(?=[^.]+$)/)
}

// Yup
export const leftPad = (x, l, padding = ' ') => {
  let s = x.toString()
  while (s.length < l) {
    s = padding + s
  }
  return s
}

/**
 * Returns a string for representing a count of some noun,
 * like "5 apples" or "1 pear", correctly using singular/plural
 * @param {*} n the number of objects
 * @param {*} noun the noun representing the object ("apple")
 * @param {*} plural the plural of the noun; if not specified, an "s" is added to the noun for plural
 * @returns
 */
export function formatCount(n, noun, plural = null) {
  return `${n} ${n !== 1 ? plural || noun + 's' : noun}`
}
